import React, { useState, useEffect } from "react";

const AdTables = ({attachmentRef}) => {
    const [showSI, setShowSI] = useState(false);
    const [selectedRows, setSelectedRows] = useState({
        AdsInfo: [],
        ForestInfo: [],
        ForestTable: [],
    });
    
    const { ad, trustedBuyer } = Window.react_data;
    const static_path  = Window.static_path;
    const isLeveransvirke = ad.type === "Leveransvirke";

    const adsInfo = {
        "Första anbudsdag": ad.start_time,
        "Sista anbudsdag": ad.end_time,
        "Åtgärd": ad.arrangement_types,
        "Gallringsuttag": ad.get_thinning,
        "Kontraktstyp": ad.name_display,
        "Avverkningsperiod från": ad.felling_start_time,
        "Avverkningsperiod till": ad.felling_end_time,
        "Leveransår": ad.delivery_year,
        "Upphämtningsdatumet": ad.pickup_date,
        "Antal dagar till betalning": ad.days_to_payment,
        "Ansvarig för avverkningsanmälan": ad.felling_application_responsible,
        "Kommun": ad.municipality,
        "Registrerad för mervärdesskatt": ad.more_tax,
        "Taxeras som lantbruksenhet": ad.agricultural_unit,
        "Önskas dellikvid / förskottsbetalning / delbetalning": ad.part_or_advance_payment_allowed,
        "Detaljer ang. dellikvid / förskottsbetalning / delbetalning": ad.part_or_advance_payment_description,
        "Medlemskap i skogsägarförening": ad.get_seller_forest_owner_union_membership_display,
    };

    const forestInfo = {
        "Areal": !isLeveransvirke ? `${ad.total_area_ha} ha` : null,
        "Fastighetsbeteckning": trustedBuyer ? ad.description_of_property : null,
        "Uttag": ad.grot_volume === "grot" ? ad.grot_volume : null,
        "Beståndets beteckning": ad.habitat_index,
        "Beståndets ålder": ad.property_age,
        "Grotuttag medges": ad.grot_included,
        "Uttag": ad.total_volume ? `${ad.total_volume} m³fub` : null,
        "Antal träd": ad.num_trees,
        "Medelstam (m3fub)": ad.average_trunk,
        "Skogen står upp": isLeveransvirke ? ad.standing_forest : null,
        "FSC-certifikat": ad.fsc_certified,
        "PEFC-certifikat": ad.pefc_certified,
        "Spara fröträd": ad.save_seed_trees,
        "Hur är fröträd markerade": ad.seed_tree_marking_description,
        "Återplantering": ad.replanting,
        "Markberedning": !isLeveransvirke ? ad.ground_preparation : null,
        "Förröjning": !isLeveransvirke ? ad.precleaning_needed : null,
        "Hyggerensing": ad.ground_clearing,
        "Vägbygge eller vägförstärkning": ad.buyer_builds_or_reinforces_road,
        "Kompletterande information gällande skogsvård": ad.service_comments,
    };

    const cleanNumbers = (num) =>
        Math.round(Number(num)).toString().replace(".0", "").replace(".", ",");

    const formatValue = (value) => {
        if (value === true) return "Ja";
        if (value === false) return "Nej";
        if (typeof value === "number") return value.toFixed(2);
        return value;
    };

    const toggleRowSelection = (tableKey, index) => {
        setSelectedRows((prevSelected) => {
            const selectedCopy = [...prevSelected[tableKey]];
            const isSelected = selectedCopy.includes(index);
            const newSelected = isSelected
                ? selectedCopy.filter((i) => i !== index)
                : [...selectedCopy, index];

            return {
                ...prevSelected,
                [tableKey]: newSelected,
            };
        });
    };

    const renderInfoTable = (data, tableKey) => (
        <table className="table table-hover text-break fs-7">
            <tbody style={{ borderColor: "#C6C9C9" }}>
                {Object.entries(data).map(
                    ([key, value], index) =>
                        value !== null &&
                        value !== undefined &&
                        value !== "" &&
                        (tableKey === "AdsInfo" ? value : true) && (
                            <tr
                                key={key}
                                className="n-fs-7"
                                style={{
                                    backgroundColor: selectedRows[tableKey]?.includes(index)
                                        ? "#60DFE0"
                                        : "inherit",
                                    color: selectedRows[tableKey]?.includes(index)
                                        ? "#1C332A"
                                        : "inherit",
                                }}
                                onClick={() => toggleRowSelection(tableKey, index)}
                            >
                                <td className="text-break" style={{ maxWidth: "150px" }}>
                                    {key}:
                                </td>
                                <td className="text-break">
                                    {key === "Uttag" ? `${cleanNumbers(ad.total_volume)} m³fub`
                                        : formatValue(value)}
                                </td>
                            </tr>
                        )
                )}
            </tbody>
        </table>
    );

    const renderForestTableHeader = () => (
        <tr>
            {!isLeveransvirke && <th style={{ fontWeight: "normal" }}>#Avd</th>}
            <th style={{ fontWeight: "normal" }}>
                {isLeveransvirke ? "" : "Uttag"}
            </th>
            {!isLeveransvirke && showSI && (
                <th style={{ fontWeight: "normal" }}>SI</th>
            )}
            {!isLeveransvirke && (
                <th style={{ fontWeight: "normal" }}>Area</th>
            )}
            {ad.wood_types &&
                ad.wood_types.map((woodName, index) => (
                    <th key={index} style={{ fontWeight: "normal" }}>
                        {woodName === "default" ? "Löv" : woodName}
                    </th>
                ))}
        </tr>
    );

    const renderForestTableBody = () => {
        const tableRows = ad.section_assortments;
        let total_vol = 0;
        let total_area = 0.0;
        let woodTotals = {};

        if (tableRows && tableRows.length > 0) {
            tableRows.forEach((item) => {
                if (item.habitat_index && !showSI) {
                    setShowSI(true);
                }
                total_vol += item.total_volume || 0;
                total_area += parseFloat(item.Hectares || 0);

                Object.keys(item.wood || {}).forEach((woodType) => {
                    woodTotals[woodType] =
                        (woodTotals[woodType] || 0) + (item.wood[woodType] || 0);
                });
            });
        }

        return (
            <>
                {tableRows &&
                    tableRows.map((item, index) => (
                        <tr
                            key={index}
                            style={{
                                backgroundColor: selectedRows.ForestTable.includes(index)
                                    ? "#60DFE0"
                                    : "inherit",
                                color: selectedRows.ForestTable.includes(index)
                                    ? "#1C332A"
                                    : "inherit",
                            }}
                            onClick={() => toggleRowSelection("ForestTable", index)}
                        >
                            {!isLeveransvirke && <td>{item.name}</td>}
                            <td>{`${cleanNumbers(item.total_volume)} m³fub`}</td>
                            {!isLeveransvirke && showSI && <td>{item.habitat_index}</td>}
                            {!isLeveransvirke && (
                                <td>{`${Number(item.Hectares).toFixed(1).replace(".", ",")} ha`}</td>
                            )}
                            {ad.wood_types.map((woodType) => (
                                <td key={woodType}>
                                    {item.wood && item.wood[woodType]
                                        ? `${cleanNumbers(item.wood[woodType])} m³fub`
                                        : "0 m³fub"}
                                </td>
                            ))}
                        </tr>
                    ))}

                <tr className="border border-top border-1 bg-primary-core-100">
                    <td className="fw-bold">Totalt:</td>
                    {!isLeveransvirke && (
                        <>
                            <td className="fw-bold">{`${cleanNumbers(total_vol)} m³fub`}</td>
                            {showSI && <td className="fw-bold"></td>}
                            <td className="fw-bold">{`${cleanNumbers(total_area)} ha`}</td>
                        </>
                    )}
                    {isLeveransvirke && (
                        <td className="fw-bold">{`${cleanNumbers(total_vol)} m³fub`}</td>
                    )}
                    {ad.wood_types.map((woodType) => (
                        <td key={woodType} className="fw-bold">
                            {`${cleanNumbers(woodTotals[woodType] || 0)} m³fub`}
                        </td>
                    ))}
                </tr>
            </>
        );
    };

    const renderAttachments = () => (
        <div id="attachments">
            <h3 className="mb-3 n-fs-5 fw-medium">Bilagor</h3>
            <table className="table table-hover">
                <tbody style={{ borderColor: "#C6C9C9" }}>
                    {ad.attachments?.map((attachment, index) => (
                        <tr key={index}>
                            <td>
                                <a
                                    href={attachment.file_url}
                                    className="d-flex n-fs-6"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src={`${static_path}img/icons/download.svg`}
                                        height="24px"
                                        width="24px"
                                        className="supp-forest-green-filter p-1"
                                        alt="Download"
                                    />
                                    {attachment.original_file_name}
                                </a>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td>
                            <a href={`/auctions/${ad.id}/kml/`} className="d-flex n-fs-6">
                                <img
                                    src={`${static_path}img/icons/download.svg`}
                                    height="24px"
                                    width="24px"
                                    className="supp-forest-green-filter p-1"
                                    alt="Download"
                                />
                                Kartfil (kml)
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <a
                                href={`/auctions/${ad.id}/shapefile/`}
                                className="d-flex n-fs-6"
                            >
                                <img
                                    src={`${static_path}img/icons/download.svg`}
                                    height="24px"
                                    width="24px"
                                    className="supp-forest-green-filter p-1"
                                    alt="Download"
                                />
                                Kartfil (zip)
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

    const hasComments = ad.comments && ad.comments.length > 0;
    const hasAttachments = ad.attachments?.length > 0;
    const isOtherAdsEmpty = !ad.other_ads_for_owner || ad.other_ads_for_owner.length === 0;

    return (
        <div className="primary-dark row flex-md-row d-flex justify-content-center mt-4 mx-1">
            {hasComments && trustedBuyer && (
                <div className="col-12 col-lg-11 bg-neutral-cloud mb-4 p-3" style={{ borderRadius: "12px" }}>
                    <p className="mb-3 n-fs-5 fw-medium">Information</p>
                    <p className="n-fs-6" style={{ whiteSpace: "pre-line" }}>{ad.comments}</p>
                </div>
            )}

            <div className="col-lg-5 col-12 mb-4 p-3 me-lg-4 bg-neutral-cloud" style={{ borderRadius: "12px" }}>
                <p className="mb-3 n-fs-5 fw-medium">Annonsdetaljer</p>
                {renderInfoTable(adsInfo, "AdsInfo")}
            </div>

            <div className="col-lg-5 col-12 mb-4 p-3 ms-lg-4 bg-neutral-cloud" style={{ borderRadius: "12px" }}>
                <p className="mb-4 n-fs-5 fw-medium">Information om skogen</p>
                {renderInfoTable(forestInfo, "ForestInfo")}
            </div>

            <div className="col-12 col-lg-11 mb-4 p-4 bg-neutral-cloud" style={{ borderRadius: "16px" }}>
                <p className="mb-4 n-fs-5 fw-medium">Skogsuppgifter</p>
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead className="n-fs-7">{renderForestTableHeader()}</thead>
                        <tbody className="n-fs-7">{renderForestTableBody()}</tbody>
                    </table>
                </div>
            </div>

            {!isOtherAdsEmpty && (
                <div className="col-lg-4 col-12 p-3 mb-4 me-lg-4 bg-neutral-cloud" style={{ borderRadius: "12px" }}>
                    <div>
                        <p className="mb-3 n-fs-5 fw-medium">Andra annonser från denna skogsägare</p>
                        <table className="table table-hover">
                            <tbody style={{ borderColor: "#C6C9C9" }}>
                                {ad.other_ads_for_owner.map((otherAd) => (
                                    <tr key={otherAd.id}>
                                        <td>
                                            <a className="d-flex n-fs-6" href={`/auctions/${otherAd.id}`}>
                                                <img
                                                    src={`${static_path}img/icons/viewPage.svg`}
                                                    height="28px"
                                                    width="28px"
                                                    className="supp-forest-green-filter p-1 pb-2"
                                                    alt="ViewPage"
                                                />
                                                {otherAd.label}
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {trustedBuyer && (hasAttachments || ad.section_assortments?.length > 0) && (
                <div className={`col-lg-${isOtherAdsEmpty ? "7" : "6"} ${!isOtherAdsEmpty ? "ms-lg-4" : "ms-lg-0"} col-12 rounded p-3 mb-4 bg-neutral-cloud`} style={{ borderRadius: "12px", display: ad?.section_assortments?.length > 0 ? 'block' : 'none' }} ref={attachmentRef} id='attachments'>
                    {renderAttachments()}
                </div>
            )}
        </div>
    );
};

export default AdTables;